import { render } from "./ButtonOnlyWithIcon.vue?vue&type=template&id=2e84dcf6&scoped=true"
import script from "./ButtonOnlyWithIcon.vue?vue&type=script&lang=js"
export * from "./ButtonOnlyWithIcon.vue?vue&type=script&lang=js"

import "./ButtonOnlyWithIcon.vue?vue&type=style&index=0&id=2e84dcf6&lang=scss&scoped=true"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e84dcf6"]])

export default __exports__